import { Link } from 'react-router-dom';

export default function Footer() {
  const cards = [
    { name: '三井住友カード（NL）', href: '/mitsui' },
    { name: '大手ECモール系カード', href: '/ec-mall-card' },
    { name: '高還元率カード', href: '/recruit' },
    { name: 'dカード GOLD U', href: '/dcard' },
    { name: '地方銀行系スピード発行カード', href: '/suruga' },
    { name: 'デポジット型クレジットカード', href: '/nexus' }
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900 text-white py-16">
      <div className="max-w-6xl mx-auto px-4">
        {/* ランキングへの目立つリンク */}
        <div className="mb-12 text-center">
          <Link
            to="/ranking"
            className="inline-flex items-center gap-3 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-bold px-8 py-4 rounded-2xl transition-all shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer"
          >
            <i className="ri-trophy-line text-2xl"></i>
            <span className="text-lg">人気クレジットカード比較ランキングはこちら</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>

        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
                <i className="ri-bank-card-line text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold">クレカ比較ナビ</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              あなたにぴったりのクレジットカードを見つけるお手伝いをします
            </p>
          </div>

          <div>
            <h4 className="font-bold mb-4">人気カード</h4>
            <ul className="space-y-2">
              {cards.map((card, index) => (
                <li key={index}>
                  <Link to={card.href} className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
                    {card.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4">カテゴリー</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/ranking" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
                  人気ランキング
                </Link>
              </li>
              <li>
                <Link to="/free" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
                  年会費無料
                </Link>
              </li>
              <li>
                <Link to="/highreturn" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
                  高還元率
                </Link>
              </li>
              <li>
                <Link to="/instant" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
                  即日発行
                </Link>
              </li>
              <li>
                <Link to="/student" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
                  学生向け
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4">お役立ち記事</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/articles/instant-issue" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
                  即日発行カード
                </Link>
              </li>
              <li>
                <Link to="/articles/free-annual-fee" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
                  年会費無料カード
                </Link>
              </li>
              <li>
                <Link to="/articles/high-return-rate" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
                  高還元率カード
                </Link>
              </li>
              <li>
                <Link to="/articles/student-cards" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
                  学生向けカード
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            &copy; 2026 クレカ比較ナビ. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
